module.exports = __webpack_public_path__ + "img/imagen9.249e3de1.png";